import { subscribe } from './subscribe';
import { showMessage } from '../../common/messages/framework/store/message-actions';
import { POST_SUBSCRIBED } from '../components/messages/message-types';

export function subscribeToPost(_id) {
  return (dispatch) =>
    dispatch(subscribe({ _id, type: 'post' })).then(() => dispatch(showMessage(POST_SUBSCRIBED)));
}
